import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { InputBase, InputPassword, TextAreaBase } from "./styles";

const CustomInput = ({
  id,
  type = "text",
  placeholder,
  value,
  defaultValue,
  onChange,
  onBlur,
  variant = "gray",
  disabled = false,
  isError = false,
  id_attribute,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  if (type === "textarea") {
    return (
      <TextAreaBase
        id={id}
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        variant={variant}
        disabled={disabled}
        isError={isError}
      />
    );
  }

  return type === "password" ? (
    <InputPassword>
      <input
        id={id}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        variant={variant}
        disabled={disabled}
        isError={isError}
      />
      <span
        onClick={handleTogglePassword}
        className="material-icons"
        style={{ cursor: "pointer", color: "#CBCBCB", fontSize: "18px" }}
      >
        {showPassword ? "visibility_off" : "visibility"}
      </span>
    </InputPassword>
  ) : (
    <InputBase
      id={id}
      type={type}
      placeholder={placeholder}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      onBlur={onBlur}
      variant={variant}
      disabled={disabled}
      isError={isError}
    />
  );
};

CustomInput.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    "text",
    "email",
    "password",
    "number",
    "tel",
    "textarea",
  ]),
  placeholder: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["gray", "graylight"]),
  disabled: PropTypes.bool,
  isError: PropTypes.bool,
};

export default CustomInput;
